<template>
    <detail-editor-layout :title="$route.meta.type === 'create' ? $t('forms.create_form_title') : $t('forms.edit_form_title')">
        <div class="editor">
            <div class="ed-form">
                <form-broker :form-data="formData" v-model="customerInfo" @update:modelValue="update"></form-broker>
            </div>
            <div class="ed-preview">
                <div class="ed-el">
                    <widget-view :is-preview="true" :customer-info="customerInfo"></widget-view>
                </div>
            </div>
        </div>
    </detail-editor-layout>
</template>
<style scoped lang="scss">
    .editor {
        display: flex;
        gap: 12px;

        .ed-preview {
            border-radius: 6px;
            border: 1px solid #a0a0a0;
            background-color: #dadada;
            padding: 20px;

            .ed-el {
                padding: 10px;
                border-radius: 3px;
                border: 1px solid #c7c7c7;
                background-color: white;
            }
        }
    }
</style>
<script setup>
    import {
        ref
    } from 'vue';
    import FormBroker from '../../components/ui-components/FormBroker.vue';
    import DetailEditorLayout from '../../components/view-components/DetailEditorLayout.vue';
    import WidgetView from "../../../widget/views/WidgetView.vue";
    const update = (val) => {
        customerInfo.value = val;
    }
    const customerInfo = ref({
        logo: 'http://localhost:8080/img/logo.661f1b58.svg',
        calendar: {
            firstDayOfWeek: 2,
            titlePosition: 'center',
            transition: 'fade',
            locale: 'cs_CZ',
            showWeekNumbers: false,
            view: 'monthly',
        },
        theme: {
            color: 'green',
            borderless: false,
            transparent: false,
            darkMode: false,
            fontFamily: 'Syne',
            rows: 1,
            columns: 1,
            roundness: 1
        }
    });

    const formData = ref([{
            fieldset: 'Obecné',
            children: [{
                    id: 'name',
                    type: 'text',
                    label: 'Označení formuláře',
                    help: 'Označení formuláře bude zobrazeno v karetním zobrazení prohlížeče a budete jím moci vyhledávat.'
                },
                {
                    id: 'calendar.locale',
                    type: 'select',
                    label: 'Jazyk a formáty formuláře',
                    placeholder: 'Vyberte jazyk',
                    help: 'Vybraný jazyk bude měnit nejen nápisy, ale také formát data',
                    render_as: 'flag',
                    children: [{
                            id: 'cs_CZ',
                            value: 'cs_CZ',
                            label: 'čeština (Česko)'
                        },
                        {
                            id: 'en_US',
                            value: 'en_US',
                            label: 'English (USA)'
                        },
                        {
                            id: 'ko_KR',
                            value: 'ko_KR',
                            label: '한국어 (대한민국)'
                        }
                    ]
                },
                {
                    id: 'id_calendar_providers',
                    type: 'select',
                    label: 'Poskytovatel kalendáře',
                    render_as: 'calendar_provider',
                    children: [{
                            id: 1,
                            value: 'google',
                            label: 'Google Kalendář'
                        },
                        {
                            id: 2,
                            value: 'outlook',
                            label: 'Kalendář Microsoft'
                        },
                        {
                            id: 3,
                            value: 'exchange',
                            label: 'Firemní kalendář Exchange'
                        }
                    ]
                },
                {
                    id: 'id_reservation_form_types',
                    type: 'select',
                    label: 'Typ formuláře',
                    children: [{
                        id: 1,
                        label: 'Osobní',
                        value: 1
                    }]
                }
            ]
        },
        {
            fieldset: 'Nastavení kalendáře',
            children: [{
                    id: 'calendar.firstDayOfWeek',
                    type: 'select',
                    label: 'První den týdne',
                    children: [{
                            value: 2,
                            label: 'Pondělí'
                        },
                        {
                            value: 3,
                            label: 'Úterý'
                        },
                        {
                            value: 4,
                            label: 'Středa'
                        },
                        {
                            value: 5,
                            label: 'Čtvrtek'
                        },
                        {
                            value: 6,
                            label: 'Pátek'
                        },
                        {
                            value: 7,
                            label: 'Sobota'
                        },
                        {
                            value: 1,
                            label: 'Neděle'
                        },
                    ]
                },
                {
                    id: 'calendar.view',
                    type: 'switch',
                    label: 'Rozložení kalendáře',
                    children: [
                        {
                            label: 'Měsíční',
                            value: 'monthly',
                        },
                        {
                            label: 'Týdenní',
                            value: 'weekly'
                        }
                    ]
                },
                {
                    id: 'theme.columns',
                    type: 'number',
                    label: 'Počet sloupců',
                    min: 1,
                    max: 2
                },
                {
                    id: 'theme.rows',
                    type: 'number',
                    label: 'Počet řádků',
                    min: 1,
                    max: 2
                },
            ]
        },
        {
            fieldset: 'Vzhled kalendáře',
            children: [
                {
                    id: 'theme.color',
                    type: 'select',
                    label: 'Zabarvení formuláře',
                    render_as: 'color',
                    children: [
                        {
                            label: 'Zelená',
                            value: 'green',
                        },
                        {
                            label: 'Modrá',
                            value: 'blue'
                        },
                        {
                            label: 'Žlutá',
                            value: 'yellow'
                        },
                        {
                            label: 'Fialová',
                            value: 'purple'
                        },
                        {
                            label: 'Červená',
                            value: 'red'
                        }
                    ]
                },
                {
                    id: 'theme.roundness',
                    type: 'slider',
                    label: 'Zaokrouhlení výběrovníku dne',
                    min: 0,
                    max: 3
                },
                {
                    id: 'theme.darkMode',
                    type: 'switch',
                    label: 'Vzhled',
                    children: [
                        {
                            label: 'Světlý',
                            value: false
                        },
                        {
                            label: 'Tmavý',
                            value: true
                        }
                    ]
                },
                {
                    id: 'theme.transparent',
                    type: 'switch',
                    label: 'Pozadí',
                    children: [
                        {
                            label: 'Průhledné',
                            value: true
                        },
                        {
                            label: 'Zabarvené',
                            value: false
                        }
                    ]
                },
                {
                    id: 'calendar.titlePosition',
                    type: 'switch',
                    label: 'Poloha nadpisu',
                    children: [
                        {
                            icon: 'pi pi-align-left',
                            value: 'left'
                        },
                        {
                            icon: 'pi pi-align-center',
                            value: 'center'
                        },
                        {
                            icon: 'pi pi-align-right',
                            value: 'right'
                        }
                    ]
                },
                {
                    id: 'theme.borderless',
                    type: 'switch',
                    label: 'Okraj',
                    children: [
                        {
                            label: 'Bez okraje',
                            value: true
                        },
                        {
                            label: 'S okrajem',
                            value: false
                        }
                    ]
                },
                {
                    id: 'logo',
                    type: 'fileUpload',
                    label: 'Logo'
                }
            ]
        }
    ])
</script>
